import { PHONEME_INVENTORY } from "@/data/ttv/requests/phonemeDictionary/phonemeInventory";

export const isValidPhoneme = (phonemeString: string): boolean =>
  PHONEME_INVENTORY.has(phonemeString.trim().toLowerCase());
